import React from "react";
import { WhatConta, Header } from "../../containers";
import { Footer, Form } from "../../components";
import Navbar from "../navbar/Navbar";
import { Box } from "@chakra-ui/react";

export default function Home() {
  return (
    <Box>
      <Navbar />
      <Header />
      <WhatConta />
      <Form />
      <Footer />
    </Box>
  );
}
